import { AjaxHelper } from '../../http/ajax_helper';

export abstract class CommonAlbumsManager {
    
    constructor() {        
    }
   /**
   * Method to get the shared token by album id.   
   * @param {string} payload
   * @returns {Promise<any>}
   * @memberof CommonAlbumsModule
   */
    getShareTokenForAlbum(apiBaseUrl: string, payload: string): Promise<any> {

        const url = "social/public";

       let config = {
           url: apiBaseUrl + '/request_api',
           type: "POST",
           async: false,
           data: JSON.stringify({uriTemplate: url,version: "v2", type: "POST", req_service: "pict",url: url, data: payload })
       }

        let promise = AjaxHelper.triggerApi({ requestConfig: config });
        return promise;
    }
    /**
     * Method to create a new album with the added assets.   
     * @param {string} payload
     * @returns {Promise<any>}
     * @memberof CommonAlbumsModule
     */
    createAlbum(apiBaseUrl: string, payload: string): Promise<any> {
        const url = "collection";
        let config = {
            url: apiBaseUrl + '/request_api',
            type: "POST",
            data: JSON.stringify({uriTemplate: url,version: "v2", type: "PUT", req_service: "pict",url: url, data: payload })
        }
        let promise = AjaxHelper.triggerApi({ requestConfig: config });
        return promise;
    }
}